<template>
  <div class="site-wrapper">
    <StoreHeader></StoreHeader>
    <router-view />
    <Footer></Footer>
  </div>
</template>
<script>
import StoreHeader from "@/components/storeHeader";
import Footer from "@/components/footer"
export default {
  name: 'Layout',
  components: {
    StoreHeader,
    Footer
  },
  data() {
    return {

    }
  }
}
</script>
<style lang='scss' scoped></style>
